export default (): boolean => window.location.pathname.indexOf('/profile/daily-recommendations') !== -1;
